import type { HTMLAttributes } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

import AccessoriesCard from './activities/AccessoriesCard';
import CreditAppCard from './activities/CreditAppCard';
import { DocUploadCard } from './activities/DocUploadCard';
import FinishDealCard from './activities/FinishDealCard.interstate';
import IncentivesCard from './activities/IncentivesCard';
import ReservationCard from './activities/ReservationCard';
import TestDriveCard from './activities/TestDriveCard';
import TradeCard from './activities/TradeCard';
import TemplatesCard from './activities/TemplatesCard';
import VppActivityVehicleProtectionCard from './activities/VppActivityVehicleProtectionCard';
import DigitalDealJacketLink from './activities/DigitalDealJacketLink';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as activitiesStatusSelectors from '@makemydeal/dr-dash-store/selectors/activitiesStatusSelectors';
import { ConditionalProfiler } from '../telemetry';

export const DealActivity: React.FC<HTMLAttributes<HTMLDivElement>> = () => {
    const isDealCentralExperience = useSelector(dealerSelectors.isDealCentralExperience);
    const enableDigitalDealJacket = useSelector(dealerSelectors.enableDigitalDealJacket);
    const isReservationCardHidden = useSelector(featureToggleSelectors.disableReservationActivityLink);
    const isTestDriveAvailable = useSelector(activitiesStatusSelectors.isTestDriveAvailable);
    return (
        <ConditionalProfiler id="deal-activity-cards">
            <IncentivesCard />
            <TradeCard />
            <VppActivityVehicleProtectionCard />
            <AccessoriesCard />
            <CreditAppCard />
            {isTestDriveAvailable && <TestDriveCard />}
            <DocUploadCard />
            {!isReservationCardHidden && <ReservationCard />}
            <TemplatesCard />
            {!isDealCentralExperience && (
                <>
                    <FinishDealCard />
                    {enableDigitalDealJacket && <DigitalDealJacketLink />}
                </>
            )}
        </ConditionalProfiler>
    );
};

export default DealActivity;
